export enum ContactPaymentsStatusEnum {
  draft = 'draft',
  pending = 'pending',
  completed = 'completed',
  refund_processing = 'refund_processing',
  refunded = 'refunded',
  canceled = 'canceled',
}

export const ContactPaymentsStatus: Record<ContactPaymentsStatusEnum, string> = {
  [ContactPaymentsStatusEnum.canceled]: 'dashboard.payment_status.canceled',
  [ContactPaymentsStatusEnum.pending]: 'dashboard.payment_status.pending',
  [ContactPaymentsStatusEnum.refund_processing]: 'dashboard.payment_status.refund_processing',
  [ContactPaymentsStatusEnum.completed]: 'dashboard.payment_status.completed',
  [ContactPaymentsStatusEnum.draft]: 'draft',
  [ContactPaymentsStatusEnum.refunded]: 'dashboard.payment_status.refunded',
}
